import { useState } from "react";
import { X } from "lucide-react";

// David's welcome popup — shown a few seconds after a founder lands on the
// dashboard, every login, until they click "Do not show this again".
export const DavidWelcomePopup = ({ firstName, onClose, onNever, onStartTour, onOpenFaq, onPickHuman }) => {
  const [view, setView] = useState("menu"); // menu | human

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4"
      data-testid="david-popup-overlay"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
        data-testid="david-popup"
        role="dialog"
        aria-modal="true"
        aria-label="David — your Clinq guide"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src="/david-avatar.jpg" alt="David" className="h-12 w-12 rounded-full object-cover ring-2 ring-[#0A8B85]/30" />
            <p className="text-sm font-bold text-neutral-900">David · Your Clinq guide</p>
          </div>
          <button data-testid="david-popup-close" onClick={onClose}
            className="rounded-full p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700">
            <X className="h-4 w-4" />
          </button>
        </div>

        {view === "menu" ? (
          <>
            <p className="mt-4 text-base font-semibold leading-relaxed text-neutral-900" data-testid="david-popup-greeting">
              Hi {firstName}, I am David — your Clinq guide. How can I help you today?
            </p>
            <div className="mt-4 space-y-2.5">
              <button data-testid="david-popup-tour" onClick={onStartTour}
                className="block w-full rounded-xl border border-neutral-200 px-4 py-3 text-left text-sm font-semibold text-neutral-800 transition-colors hover:border-[#0A8B85] hover:bg-[#0A8B85]/5">
                Take me through the platform
                <span className="mt-0.5 block text-[11px] font-normal text-neutral-500">A guided walkthrough of every page and why it matters</span>
              </button>
              <button data-testid="david-popup-faq" onClick={onOpenFaq}
                className="block w-full rounded-xl border border-neutral-200 px-4 py-3 text-left text-sm font-semibold text-neutral-800 transition-colors hover:border-[#0A8B85] hover:bg-[#0A8B85]/5">
                How does Clinq work?
                <span className="mt-0.5 block text-[11px] font-normal text-neutral-500">Chat with me — I&apos;ll answer the questions founders ask most</span>
              </button>
              <button data-testid="david-popup-human" onClick={() => { onPickHuman?.(); setView("human"); }}
                className="block w-full rounded-xl border border-neutral-200 px-4 py-3 text-left text-sm font-semibold text-neutral-800 transition-colors hover:border-[#0A8B85] hover:bg-[#0A8B85]/5">
                I need help from a real human
                <span className="mt-0.5 block text-[11px] font-normal text-neutral-500">Hands-on support from a Clinq analyst</span>
              </button>
            </div>
          </>
        ) : (
          <div className="mt-4" data-testid="david-popup-human-view">
            <p className="text-sm leading-relaxed text-neutral-700">
              I am flattered you asked — I give great advice, remember everything,
              and never take a lunch break. But I will admit, I am not actually
              human. For hands-on support from a real Clinq analyst who will sit
              with you, prep your documents, and walk you through the whole
              process, check out our Analyst Support plans.
            </p>
            <a href="/analyst-support" target="_blank" rel="noreferrer" data-testid="david-popup-analyst-btn"
              className="mt-4 inline-flex w-full items-center justify-center rounded-lg bg-[#0A8B85] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#066667]">
              See Analyst Support Plans
            </a>
            <button data-testid="david-popup-back" onClick={() => setView("menu")}
              className="mt-2 w-full rounded-lg border border-neutral-200 px-4 py-2 text-xs font-semibold text-neutral-600 hover:bg-neutral-50">
              ← Back
            </button>
          </div>
        )}

        <button data-testid="david-popup-never" onClick={onNever}
          className="mt-4 block w-full text-center text-[11px] font-medium text-neutral-400 underline-offset-2 hover:text-neutral-600 hover:underline">
          Do not show this again
        </button>
      </div>
    </div>
  );
};
